import { render, staticRenderFns } from "./Snapshots.vue?vue&type=template&id=305ddb31&scoped=true"
import script from "./Snapshots.vue?vue&type=script&lang=js"
export * from "./Snapshots.vue?vue&type=script&lang=js"
import style0 from "./Snapshots.vue?vue&type=style&index=0&id=305ddb31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305ddb31",
  null
  
)

export default component.exports